import type { Query } from '@tanstack/react-query';

function isFilterParams(keySegment: unknown): boolean {
  return typeof keySegment === 'object' && keySegment !== null && !Array.isArray(keySegment);
}

export function keepPreviousFilteredData<TData>(
  previousData: TData | undefined,
  previousQuery: Query | undefined,
): TData | undefined {
  return isFilterParams(previousQuery?.queryKey.at(-1)) ? previousData : undefined;
}
